import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { ArrowRight, Home, Trees } from 'lucide-react';

const insideEn = ["Kitchen", "Bathroom", "Flooring", "Electrical", "Plumbing", "HVAC", "Drywall", "Interior Renovations"];
const outsideEn = ["Landscape", "Outdoor Kitchen", "BBQ Areas", "Pergolas", "Pavers", "Lighting", "Patios", "Entertainment Areas", "Home Additions"];
const insideEs = ["Cocina", "Baño", "Pisos", "Electricidad", "Plomería", "Aire Acondicionado", "Paneles", "Renovaciones Interiores"];
const outsideEs = ["Paisajismo", "Cocina Exterior", "Áreas BBQ", "Pérgolas", "Pavimentos", "Iluminación", "Patios", "Entretenimiento", "Adiciones"];

export default function InsideOut() {
  const { lang, t } = useLang();
  const inside = lang === 'es' ? insideEs : insideEn;
  const outside = lang === 'es' ? outsideEs : outsideEn;
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="inside-out" className="bg-[#12151A] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.insideOut.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 font-outfit">{t.insideOut.heading}</h2>
          <p className="text-xl sm:text-2xl text-white/80 mt-2 font-outfit font-light">{t.insideOut.sub}</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="relative overflow-hidden rounded-lg border border-white/10 bg-[#0B0D0F] p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded bg-[#D4AF37]/20 flex items-center justify-center"><Home className="w-5 h-5 text-[#D4AF37]" /></div>
              <h3 className="text-xl font-bold text-white font-outfit">{t.insideOut.interior}</h3>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {inside.map(s => (<div key={s} className="flex items-center gap-2 text-slate-300 text-sm"><div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />{s}</div>))}
            </div>
            <div className="mt-6 h-48 rounded overflow-hidden">
              <img src="https://images.unsplash.com/photo-1631048501619-a27088a3bb70?w=800" alt="Modern luxury kitchen interior" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
          <div className="relative overflow-hidden rounded-lg border border-white/10 bg-[#0B0D0F] p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded bg-[#D4AF37]/20 flex items-center justify-center"><Trees className="w-5 h-5 text-[#D4AF37]" /></div>
              <h3 className="text-xl font-bold text-white font-outfit">{t.insideOut.exterior}</h3>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {outside.map(s => (<div key={s} className="flex items-center gap-2 text-slate-300 text-sm"><div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />{s}</div>))}
            </div>
            <div className="mt-6 h-48 rounded overflow-hidden">
              <img src="https://images.unsplash.com/photo-1762117360868-d4e757073d45?w=800" alt="Modern outdoor kitchen" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        </div>
        <div className="text-center mt-10">
          <button onClick={() => scrollTo('#estimate')} data-testid="inside-out-cta"
            className="group inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#E5C158] text-black font-bold px-8 py-4 rounded text-base transition-all">
            {t.insideOut.cta}<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}
